import { useLanguagePreferenceToast } from './useLanguagePreferenceToast';

export function LanguagePreferenceToast(): null {
  useLanguagePreferenceToast();
  return null;
}
